












import { Component, Vue, Prop } from "vue-property-decorator";
import { UserBadge } from "@/models/users/user.badge";
import { UsersService } from "@/services/api/users.service";

@Component
export default class UserBadgeComponent extends Vue {
  @Prop() badge!: UserBadge;
  @Prop({ required: false, default: 30 }) size!: number;
  @Prop({ required: false, default: "grey" }) color!: string;

  get initials(): string {
    return this.badge?.name?.substring(0, 2).toUpperCase() || "";
  }

  get name(): string {
    return this.badge && this.badge.name ? this.badge.name : "";
  }

  get photoSrc(): string | null {
    return new UsersService().GetProfilePhotoSrc(this.badge.photo);
  }
}
